import { PaginateQuery } from "../../interfaces";

export function buildPaginationQueryString(
  data: PaginateQuery,
  basePath: string,
): string {
  let url = basePath;
  if (data.page) {
    url += `?page=${data.page}`;
  } else {
    url += `?page=${1}`;
  }
  if (data.limit && data.limit > 0) {
    url += `&limit=${data.limit}`;
  } else {
    url += `&limit=${10}`;
  }
  if (data.sortBy) {
    url += `&sortBy=${data.sortBy}`;
  }
  if (data.search && data.search !== "") {
    url += `&search=${data.search}`;
  }
  if (
    data.filter &&
    Object.keys(data.filter).length &&
    Object.keys(data.filter).length > 0
  ) {
    let filters: string = "";
    const filter = data.filter;
    Object.keys(filter).map((key: string) => {
      if (filter[key]) filters += `&filter[${key}]=${filter[key]}`;
    });
    url += filters;
  }
  return url;
}

export function buildLogFilterQueryString(
  data: Pick<PaginateQuery, "filter" | "search">,
  basePath: string,
): string {
  const params: string[] = [];

  if (data.search && data.search !== "") {
    params.push(`search=${encodeURIComponent(data.search)}`);
  }

  if (data.filter) {
    Object.keys(data.filter).forEach((key) => {
      const value = data.filter?.[key];
      if (value !== undefined && value !== null && String(value) !== "") {
        params.push(
          `filter[${key}]=${encodeURIComponent(String(value))}`,
        );
      }
    });
  }

  if (!params.length) {
    return basePath;
  }

  return `${basePath}?${params.join("&")}`;
}

export function buildEncodedPaginationQueryString(
  data: PaginateQuery,
  basePath: string,
): string {
  const params: string[] = [];
  params.push(`page=${data.page || 1}`);
  params.push(`limit=${data.limit && data.limit > 0 ? data.limit : 10}`);

  if (data.sortBy) {
    params.push(`sortBy=${encodeURIComponent(data.sortBy)}`);
  }
  if (data.search && data.search !== "") {
    params.push(`search=${encodeURIComponent(data.search)}`);
  }
  if (data.filter) {
    Object.keys(data.filter).forEach((key) => {
      const value = data.filter?.[key];
      if (value === undefined || value === null || String(value) === "") {
        return;
      }
      const encoded = Array.isArray(value)
        ? value.map((item) => encodeURIComponent(String(item))).join(",")
        : encodeURIComponent(String(value));
      params.push(`filter[${key}]=${encoded}`);
    });
  }

  return `${basePath}?${params.join("&")}`;
}
